import React, {useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
//Material-UI
import {makeStyles} from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Skeleton from '@material-ui/lab/Skeleton';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles(theme => {
   const elevations = {};
   theme.shadows.forEach((shadow, index) => {
      elevations[`elevation${index}`] = {
         boxShadow: shadow
      };
   });
   return {
      root: {
         minHeight: '200px',
         padding: theme.spacing(2),
         textAlign: 'center',
         color: theme.palette.text.secondary
      },
      container: {
         backgroundColor: theme.palette.background.paper,
         color: theme.palette.text.primary,
         transition: theme.transitions.create('box-shadow'),
         border: `1px solid ${theme.palette.divider}`,
         borderRadius: theme.shape.borderRadius,
         width: '100%',
         height: '100%'
      },
      img: {
         maxHeight: 118,
         maxWidth: 210
      },
      content: {
         height: '100%'
      },
      ...elevations
   };
});

export default function Producto(props) {
   const classes = useStyles();
   const {loading = false, data} = props;
   const [verMas, setVerMas] = useState(false);
   function toggleVerMas() {
      setVerMas(!verMas);
   }
   return (
      <>
         {(loading ? Array.from(new Array(3)) : data).map((item, index, arr) => (
            <Grid key={index} container item xs={3} className={classes.root}>
               {item ? (
                  verMas || index < 3 ? (
                     <Grid
                        className={clsx(classes.container, classes['elevation1'])}
                        container
                        item
                        xs={12}
                        alignContent="center"
                        justify="center"
                     >
                        <Grid container item xs={12}>
                           <Grid item xs={12}>
                              <Typography gutterBottom variant="body2">
                                 {item.producto.denominacion ? item.producto.denominacion : ''}
                              </Typography>
                           </Grid>
                           <Grid item xs={12}>
                              <img
                                 className={classes.img}
                                 alt={item.title}
                                 src="https://www.dscont.pe/dsServices/images/dscontgolden.png"
                              />
                           </Grid>

                           {item.producto.links !== undefined &&
                              item.producto.links.map(link => (
                                 <Grid key={link.codigoLink} item xs={12}>
                                    <Link key={link.codigoLink} href={link.url}>
                                       {link.denominacion}
                                    </Link>
                                 </Grid>
                              ))}
                        </Grid>

                        {arr.length > 3 &&
                        ((verMas && index === arr.length - 1) || (!verMas && index === 2)) ? (
                           <Button onClick={toggleVerMas}>
                              VER {`${verMas ? 'MENOS' : 'MÁS'}`} PROUCTOS
                           </Button>
                        ) : null}
                     </Grid>
                  ) : null
               ) : (
                  <Grid container itemd xs={12}>
                     <Skeleton variant="rect" width={210} height={118} />
                     <Box pt={0.5}>
                        <Skeleton />
                        <Skeleton width="60%" />
                     </Box>
                  </Grid>
               )}
            </Grid>
         ))}
      </>
   );
}

Producto.propTypes = {
   loading: PropTypes.bool,
   data: PropTypes.array
};
